import { useState } from 'react'
import type { FormEvent } from 'react'

import { api } from '../api/client'
import { ErrorBanner } from '../components/common'
import { LogoCompleto } from '../components/Marchio'
import { t } from '../i18n/lingua'

/**
 * La pagina dell'invito: la persona scrive la propria password.
 *
 * Pubblica per costruzione — chi arriva qui non ha ancora credenziali — e
 * difesa dal gettone nel collegamento: monouso, a scadenza. La doppia
 * immissione non è cerimonia: un refuso in una password che nessun altro
 * conosce è un'utenza da reinvitare.
 */
export default function SetPassword() {
  const token = new URLSearchParams(window.location.search).get('token') ?? ''
  const [password, setPassword] = useState('')
  const [conferma, setConferma] = useState('')
  const [busy, setBusy] = useState(false)
  const [fatto, setFatto] = useState(false)
  const [error, setError] = useState<unknown>(null)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    if (password !== conferma) {
      setError(new Error(t('Le due password non coincidono.')))
      return
    }
    setBusy(true)
    setError(null)
    try {
      await api.setPassword(token, password)
      setFatto(true)
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <form className="login__box" onSubmit={onSubmit}>
        <div className="login__marchio"><LogoCompleto size={56} /></div>
        <p className="login__prodotto">CENSO</p>

        {fatto ? (
          <>
            <p className="login__tagline">{t('Password impostata: puoi entrare.')}</p>
            <button type="button" style={{ width: '100%' }} onClick={() => { window.location.href = '/' }}>
              {t('Vai all’accesso')}
            </button>
          </>
        ) : (
          <>
            <p className="login__tagline">{t('Scegli la tua password')}</p>
            <ErrorBanner error={error} />
            {!token && (
              <p className="text-muted">
                {t('Questo collegamento è incompleto: apri quello ricevuto per email.')}
              </p>
            )}
            <div className="field">
              <label htmlFor="pw">{t('Nuova password (almeno 10 caratteri)')}</label>
              <input
                id="pw"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>
            <div className="field">
              <label htmlFor="pw2">{t('Ripetila')}</label>
              <input
                id="pw2"
                type="password"
                value={conferma}
                onChange={(e) => setConferma(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>
            <button type="submit" disabled={busy || !token || password.length < 10} style={{ width: '100%' }}>
              {busy ? t('Salvataggio…') : t('Imposta la password')}
            </button>
          </>
        )}
      </form>
    </div>
  )
}
